<form [formGroup]="verificationForm" (ngSubmit)="verifyCode()" class="mfa-challenge-content">
    <h1 class="suif-h1 verification-heading">Enter Your Verification Code</h1>

    <p class="suif-h5 verification-instructions">
        Open your authenticator app and enter the current 6-digit verification code for your account.
    </p>

    <app-message-box [content]="errors"></app-message-box>

    <app-input
        formControlName="verificationCode"
        fieldId="verification-code"
        label="Verification Code"
        placeholder="######"
        maxlength="6"
        inputmode="numeric"
        autocomplete="one-time-code"
        [errors]="errors.fieldErrors?.otp"
        [isDisabled]="verifying()"
        isRequired
        autoFocus>
    </app-input>

    <p class="suif-body-copy-small verification-note">Note: The verification code changes every 30 seconds</p>

    <div class="button-row">
        <app-wait-button
            buttonType="submit"
            [waiting]="verifying()"
            label="Confirm"
            cssClass="btn btn-verty">
        </app-wait-button>
    </div>

    <p class="suif-body-copy-small lost-access-help">Help, I've lost access to my two-step verification methods.</p>
</form>
